import APIClient from '@/shared/http/clients/api'

const resourceName = 'margem-contribuicao'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&sort=periodoMovimento,desc&page=${index}&size=${limit}`, config)

/**
 * @name MargemContribuicaoRepository
 * @description Marge contribuição
 * @type { Respository }
 */
const MargemContribuicaoRepository = {
  Search
}

export default MargemContribuicaoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/margemcontribuicao.js